module.exports = __webpack_public_path__ + "img/icon-notice.7367577e.svg";